import { Accordion, AccordionSummary, AccordionDetails, Typography, Stack, Container } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export interface FaqItem {
  question: string;
  answer: string;
}

/** Renders visible FAQ content matching whatever FaqJsonLd structured data
 * the backend's SeoMetaInjectionMiddleware injects for the same route -
 * Google's guidelines require FAQPage structured data to match real, visible
 * page content, so these two are kept in sync deliberately (not generated
 * from one shared source, since the structured data lives in the backend and
 * the visible markup lives here - see docs/SEO_AUDIT.md H4). */
export default function FaqSection({ items }: { items: FaqItem[] }) {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 5, md: 8 } }}>
      <Typography variant="h4" sx={{ fontFamily: '"Manrope", sans-serif', fontWeight: 800, mb: 4, textAlign: "center" }}>
        Frequently asked questions
      </Typography>
      <Stack spacing={1.5}>
        {items.map((item) => (
          <Accordion key={item.question} variant="outlined" disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1" fontWeight={700} component="h3">{item.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </Container>
  );
}
